import { clsx } from 'clsx';
import { type FC } from 'react';

import { type OverlayProps } from './types';

import styles from './Overlay.css';

export const Overlay: FC<OverlayProps> = props => {
  const { children, bgc, isCompact } = props;

  return (
    <div className={clsx(styles['container'], isCompact && styles['container--compact'])}>
      <div className={clsx(styles['overlay'], styles[`bgc-${bgc}`])} />
      <div className={styles['content']}>{children}</div>
    </div>
  );
};
